export default "__VITE_ASSET__CXq9K86m__"